<template>
  <div>
    <swiper-carousel
      v-if="events.length > 0"
      :events="events"
    />
    <dummy-carousel v-else />
  </div>
</template>

<script>
import { RepositoryFactory } from '../entry/api/inside/repository_factory'
import SwiperCarousel from './events/carousel'
import DummyCarousel from './events/dummy_carousel'
import * as Sentry from '@sentry/vue'

export default {
  name: 'LatestArchivedEvents',
  components: {
    SwiperCarousel,
    DummyCarousel
  },
  data () {
    return {
      events: []
    }
  },
  created () {
    const EventsFactory = RepositoryFactory.get('latest_archived_events')
    EventsFactory.get()
      .then(response => {
        this.events = response.data.events
      })
      .catch(error => {
        Sentry.captureException(error)
      })
  }
}
</script>
